import { Graphics2D } from './java/Graphics2D';
import { Rectangle } from './java/Geom';
import { ID } from './ID';

export abstract class GameObject {
  protected x: number;
  protected y: number;
  protected id: ID;
  protected velX = 0;
  protected velY = 0;

  constructor(x: number, y: number, id: ID) {
    this.x = x;
    this.y = y;
    this.id = id;
  }

  abstract tick(): void;

  abstract render(g: Graphics2D): void;

  abstract getBounds(): Rectangle;

  setX(x: number): void { this.x = x; }
  setY(y: number): void { this.y = y; }
  getX(): number { return this.x; }
  getY(): number { return this.y; }

  setID(id: ID): void { this.id = id; }
  getId(): ID { return this.id; }

  setVelX(velX: number): void { this.velX = velX; }
  setVelY(velY: number): void { this.velY = velY; }
  getVelX(): number { return this.velX; }
  getVelY(): number { return this.velY; }

  /** Combat mode: take damage from player. Returns true if damage was accepted. */
  takeDamage(_dmg: number): boolean { return false; }
}
